module.exports = __webpack_public_path__ + "static/media/squiggle-cord.cf4ba8dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/squiggle-cord.svg
// module id = 33
// module chunks = 0